import { createFileRoute } from '@tanstack/react-router'
import LeadsListPage from '@/pages/leads/leads-list'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/leads
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/leads',
)({
  component: function LeadsListRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.LEADS} dashboardId={dashboardId}>
        <ProtectedRoute
          anyOf={[CAPABILITIES.LEADS_ALL, CAPABILITIES.LEADS_OWN]}
          dashboardId={dashboardId}
        >
          <LeadsListPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
